/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetupParameterKindListViewModel } from '../../models/setup-parameter-kind-list-view-model';

export interface GetSetupParameterKinds$Params {
  setupParameterKindId?: number | null;
  externalSetupParameterKindId?: string | null;
  workCenterId?: number | null;
  setupGroupId?: string | null;
}

export function getSetupParameterKinds(http: HttpClient, rootUrl: string, params?: GetSetupParameterKinds$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SetupParameterKindListViewModel>>> {
  const rb = new RequestBuilder(rootUrl, getSetupParameterKinds.PATH, 'get');
  if (params) {
    rb.query('setupParameterKindId', params.setupParameterKindId, {});
    rb.query('externalSetupParameterKindId', params.externalSetupParameterKindId, {});
    rb.query('workCenterId', params.workCenterId, {});
    rb.query('setupGroupId', params.setupGroupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SetupParameterKindListViewModel>>;
    })
  );
}

getSetupParameterKinds.PATH = '/api/v1/SetupParameter/GetSetupParameterKinds';
